import { Schema } from 'rsuite'
import { SHIPPING_TYPES } from '@@partner:config/shipping-types'

const { StringType, ObjectType } = Schema.Types

export default Schema.Model({
  'recipientInfo.firstName': StringType().isRequired(
    'Укажите фамилию получателя'
  ),
  'recipientInfo.lastName': StringType().isRequired('Укажите имя получателя'),
  shippingSide: StringType().isRequired('Выберите схему доставки'),
  assemblingSide: StringType().isRequired('Выберите способ сборки'),
  shop_id: StringType().isRequired('Выберите магазин'),
  address: StringType().addRule(
    (value, state) => {
      if (state.shippingSide) {
        const shippingType = SHIPPING_TYPES?.[state?.shippingSide] ?? null

        if (!shippingType?.needAddress) {
          return true
        }

        if (!value || value.length === 0) {
          return false
        }
        else {
          return true
        }
      }
      return false
    },
    'Укажите адрес доставки',
    true
  )
})
